import { Directive, ElementRef, Input, effect, inject } from '@angular/core';
import { ThemeHighlightService } from '../_services/theme-highlight.service';

/**
 * Directive that highlights elements when their theme variable is focused
 * in the theme playground. Automatically adds/removes the highlight class
 * based on the ThemeHighlightService signal.
 *
 * Usage: <div data-theme-key="--primary">...</div>
 */
@Directive({
  selector: '[data-theme-key]',
  standalone: true
})
export class ThemeHighlightDirective {
  private el = inject(ElementRef);
  private themeHighlight = inject(ThemeHighlightService);

  @Input('data-theme-key') themeKey!: string;

  constructor() {
    // Watch for changes to highlighted variable
    effect(() => {
      const highlightedVar = this.themeHighlight.highlightedVariable();

      if (this.themeKey.includes(highlightedVar) && highlightedVar !== '') {
        // Add highlight class
        // this.el.nativeElement.classList.add('theme-preview-highlight');
      } else {
        // Remove highlight class
        this.el.nativeElement.classList.remove('theme-preview-highlight');
      }
    });
  }
}
